
  <div [formGroup]="customFieldDateForm" class="row mt-3">
    <div class=" {{fromQuickCall ? 'col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12' :'col-md-4 col-lg-4 col-xl-4'}}">
      <label class="label" for="{{ fieldId }}">
        {{ displayName }}:
        <span *ngIf="required" id="mandatory_field">&#42;</span>
      </label>
    </div>

    <div class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12' :'col-md-7 col-lg-6 col-xl-6 col-10'}} sd_custom_input">
      <input class="form-control" id="{{ (id !== null) ? id + 'qc' + fieldId : fieldId }}" type="text" value="{{ defaultValue }}" formControlName="data" [ngClass]="{'error-class':customFieldDateForm.controls['data'].touched && customFieldDateForm.controls['data'].errors?.required}"
        maxlength="256" autocomplete="off">
      <div *ngIf="customFieldDateForm.controls['data'].touched && !customFieldDateForm.controls['data'].valid" class="validation-error-inline text-danger">
        {{ displayName }} {{ 'CustomField.fieldRequired' | translate }}
      </div>
    </div>

    <span *ngIf="dscEnable === 1" [attr.data-toggle]="fieldId" data-trigger="hover" [attr.data-content]="description" class="align_description_icon">
        <em class="fa fa-question-circle fa-lg"></em>
    </span>
  </div>
